module.exports = __webpack_public_path__ + "static/media/FiraSans-SemiBold.251b0060.ttf";